const ExtendedPool = require('ExtendedPool');
const hideTween = { opacity: 0 };
const moveEasing = { easing: 'sineInOut' };
const moveBackEasing = { easing: 'backInOut' };
const flyTime = 0.45;
const delayTime = 0.05;
const SpecialWild = require('SpecialWild');
const CameraController = require('CameraController');
const AudioMap = require('AudioMap');


cc.Class({
    extends: cc.Component,

    properties: {
        cameraController: CameraController,
        blockPrefab: cc.Prefab,
        roamingWildPrefab: cc.Prefab,
        topContainer: cc.Node,
    },

    onLoad () {
        this.audioMap = cc.find("AudioMap").getComponent(AudioMap);
        this.gridSize = { width: this.blockPrefab.data.width, height: this.blockPrefab.data.height };
        // this.gridSize = { width: 185, height: 180 };
        this.pool = new ExtendedPool(this.roamingWildPrefab, 10);
        this.actives = [];
        this.targetParent = this.node;
    },

    prepareWilds(nbWilds) {
        return new Promise(resolve => {
            this.nb = nbWilds;
            for (let i = 0; i < this.nb; i++) {
                this._spawn(i * .2, this._getPos(Math.floor(i / 5) + 2, i % 5));
            }

            this.scheduleOnce(resolve, 2.5);
        });
    },

    appear (data, slamStop) {
        this.slamStop = slamStop;
        this.nb = data.length;

        this.data = data.slice(0);

        for(let i = 0; i < this.data.length; i++) {
            const { row, reel } = this.data[i];
            this._spawn(i * 0.5, this._getPos(row, reel), this.data[i]);
        }
        return new Promise(resolve => this.scheduleOnce(resolve, this.nb * .5 + 0.2));
    },

    _spawn(delay, pos, dataItem) {
        this.scheduleOnce(() => {
            const node = this.pool.get();
            const controller = node.getComponent(SpecialWild);
            node.parent = this.targetParent;
            node.setParentKeepPosition(this.topContainer);

            node.x = pos.x;
            node.y = 1500;
            cc.tween(node).
                to(0.75, { y: pos.y }, moveBackEasing).
                call(() => {
                    controller.spawn().then(() => {
                        node.setParentKeepPosition(this.targetParent);
                    });
                    if (this.slamStop) {
                        this.audioMap.playSfx('wildAttention');
                    } else {
                        this.audioMap.playSfx('specialWildAttention');
                    }
                    this.cameraController.shake();

                }).
                start();



            if (dataItem) {
                dataItem.item = controller;
            }

            this.actives.push(controller);
        }, delay);
    },

    clear () {
        while (this.actives.length) {
            const contorller = this.actives.pop();
            const delay = this.actives.length * 0.1;

            this._hide(contorller, .1);
        }

        this.data = null;
    },


    getWildAt({ row, reel }) {
        if (!this.data) {
            return null;
        }
        for (let i = 0; i < this.data.length; i ++) {
            const dataItem = this.data[i].coordinates;
            if (row === dataItem.row && reel === dataItem.reel) {
                return this.data[i].item;
            }
        }

        return null;
    },

    _hide (controller, delay = 0) {
        const item = controller.node;

        cc.tween(item).
        delay(delay).
        call(() => {
            item.setParentKeepPosition(this.topContainer);
            controller.kill();
        }).
        // delay(0.85).
        // to(flyTime, pos, moveEasing).
        call(() => {
            item.parent = null;
            this.pool.set(item);
        }).
        start();
    },

    isActive () {
        return this.actives.length > 0;
    },

    _getPos (row, reel) {
        return {
            x: (reel - 2.5) * this.gridSize.width,
            y: -(row ) * this.gridSize.height + 95
        }
    }

});
